import ECSEditorContext from 'contexts/ECSEditorContext';
import ECSOverlayContext from 'contexts/ECSOverlayContext';
import ECSWorldContext from 'contexts/ECSWorldContext';
import { Components } from 'editor/components';
import CarnivoreSheet from 'editor/components/CarnivoreSheet';
import Overlay from 'editor/components/Overlay';
import React, {
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';

type Props = PropsWithChildren<{
  sheetComp: CarnivoreSheet;
  id: string;
  index: number;
  additionalComponents: Components[];
}>;

const ECSSheetOverlay: FC<Props> = (props: Props) => {
  const { children, sheetComp, id, index, additionalComponents } = props;
  const world = useContext(ECSWorldContext);
  const { doc, carnCtx } = useContext(ECSEditorContext);
  const [sheetOverlay, setSheetOverlay] = useState<Overlay | null>(null);

  useEffect(() => {
    const _sheetOverlay = new Overlay(id, index);
    // const _markupOverlay = new MarkupOverlay(id, index);

    const entity = world
      .createEntity()
      .add(carnCtx)
      .add(doc)
      .add(sheetComp)
      .add(_sheetOverlay);

    additionalComponents.forEach((component) => {
      entity.add(component);
    });

    setSheetOverlay(_sheetOverlay);

    return () => {
      entity.destroy();
    };
  }, []);

  useEffect(() => {
    return () => {
      if (sheetOverlay) {
        sheetOverlay.destroy();
      }
    };
  }, [sheetComp, sheetOverlay]);

  return sheetOverlay ? (
    <ECSOverlayContext.Provider value={sheetOverlay}>
      {children}
    </ECSOverlayContext.Provider>
  ) : null;
};

export default ECSSheetOverlay;
